import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-entp2",
  "use": "icon-entp2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-entp2\"><defs><style type=\"text/css\"></style></defs><path d=\"M682.666667 331.580952V902.095238H170.666667V121.904762h512v209.67619zM268.190476 268.190476v121.904762h121.904762v-121.904762h-121.904762z m195.047619 0v121.904762h121.904762v-121.904762h-121.904762z m-195.047619 219.428572v121.904762h121.904762v-121.904762h-121.904762z m195.047619 0v121.904762h121.904762v-121.904762h-121.904762zM707.047619 902.095238V463.238095h146.285714v438.857143z\" p-id=\"2201\" /><path d=\"M97.52381 828.952381h828.95238v73.142857H97.52381z\" p-id=\"2202\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/entp2.svg
// module id = 5YyH
// module chunks = 68